import cx from 'classnames';
import { Switch } from 'radix-ui';

import { noop } from 'f';
import ToggleProps from './Toggle.props';

const Toggle = ({
  isOn = true,
  toggledColor = 'bg-green-700',
  toggledColorDot = 'bg-white',
  handleToggle = noop
}: ToggleProps): React.ReactNode => {
  const toggleRootClasses = cx(
    'relative h-5 w-10 rounded-full bg-gray-500 shadow-[0_2px_10px_rgba(0,0,0,0.25)]',
    '-webkit-tap-highlight-color-transparent',
    isOn && toggledColor
  );

  const toggleDotClasses = cx(
    'block h-4 w-4 rounded-full shadow-[0_2px_2px_rgba(0,0,0,0.2)]',
    'transition-transform duration-100',
    'data-[state=checked]:translate-x-[22px]',
    'data-[state=unchecked]:translate-x-[2px]',
    toggledColorDot
  );

  return (
    <Switch.Root
      checked={isOn}
      onCheckedChange={handleToggle}
      className={toggleRootClasses}
    >
      <Switch.Thumb className={toggleDotClasses} />
    </Switch.Root>
  );
};

export default Toggle;
